import { jsx, jsxs, Fragment } from "@emotion/react/jsx-runtime";
import { InputBase, Select as Select$1 } from "@mui/material";
import clsx from "clsx";
import { inputStyles } from "../TextField/TextField.styles.js";
import { ChevronDown } from "react-feather";
import { menuPaperStyles } from "../Menu/Menu.styles.js";
import { forwardRef } from "react";
import { deepmerge } from "../../utils/deepmerge.js";
import { selectStyles, placeholderMenuItemStyles } from "./Select.styles.js";
import { TextInputWrapper } from "../../wrappers/TextInputWrapper/TextInputWrapper.js";
import { MenuItem } from "../MenuItem/MenuItem.js";
import { Typography } from "../Typography/Typography.js";
const Select = forwardRef(function Select2({
  FormHelperTextProps,
  helperText,
  InputLabelProps,
  label,
  error = false,
  disabled = false,
  className,
  children,
  inputProps,
  placeholder,
  inputRef,
  id,
  // set default value to empty string so placeholder works
  defaultValue = "",
  MenuProps,
  renderValue,
  ...props
}, ref) {
  const helperTextId = helperText && id ? `${id}-helper-text` : void 0;
  const inputLabelId = label && id ? `${id}-label` : void 0;
  const mergedMenuProps = deepmerge({
    slotProps: {
      paper: {
        sx: menuPaperStyles
      }
    }
  }, MenuProps);
  if ("labelId" in props) {
    console.warn("Ascend Select: labelId prop is already auto generated based on the 'id' prop");
  }
  const InputElement = /* @__PURE__ */ jsx(InputBase, { className: clsx(className && `Ascend-inputBase-${className}`), css: inputStyles, disabled, error, inputRef, id });
  const renderPlaceholder = /* @__PURE__ */ jsx(Typography, { className: "Ascend-select-placeholder", variant: "bodyMd", children: placeholder });
  const renderMultipleValue = (value) => {
    if (renderValue)
      return renderValue(value);
    if (Array.isArray(value))
      return value.length > 0 ? value.join(", ") : renderPlaceholder;
    console.warn("Ascend Select: value should be an array when 'multiple' = true");
    return /* @__PURE__ */ jsx(Fragment, { children: value });
  };
  return /* @__PURE__ */ jsx(TextInputWrapper, { FormHelperTextProps, InputLabelProps, helperText, inputLabelId, label, error, disabled, className: clsx("Ascend-select-root", className && `Ascend-select-root-${className}`), userClassName: className, fullWidth: props.fullWidth, id, helperTextId, children: /* @__PURE__ */ jsxs(Select$1, { ref, css: selectStyles, "aria-describedby": helperTextId, labelId: inputLabelId, inputProps, input: InputElement, displayEmpty: true, IconComponent: ChevronDown, defaultValue, renderValue: props.multiple ? renderMultipleValue : renderValue, MenuProps: mergedMenuProps, ...props, children: [
    placeholder && /* @__PURE__ */ jsx(MenuItem, { css: placeholderMenuItemStyles, className: "Ascend-MenuItem-placeholder", value: "", children: renderPlaceholder }),
    children
  ] }) });
});
export {
  Select
};
//# sourceMappingURL=Select.js.map
